/**
 * Locale definitions for `vue-datepicker-next`.
 *
 * Why this exists:
 * The upstream locale bundles (e.g. `vue-datepicker-next/locale/pt-br`) are UMD
 * modules that can behave differently between Vite dev and production builds,
 * leading to runtime errors like: "Uncaught TypeError: ...default.locale is not a function".
 *
 * Passing the `lang` object directly to the component avoids that interop issue.
 */

export const ptBrDatePickerLang = {
  formatLocale: {
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    monthsShort: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    weekdays: [
      'Domingo',
      'Segunda-feira',
      'Terça-feira',
      'Quarta-feira',
      'Quinta-feira',
      'Sexta-feira',
      'Sábado',
    ],
    weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    weekdaysMin: ['Do', '2ª', '3ª', '4ª', '5ª', '6ª', 'Sá'],
    firstDayOfWeek: 0,
    firstWeekContainsDate: 6,
  },
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true,
};
